import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useApplication } from '../../AppContext';

const CreateRoom = ({ room, setRoom }) => {

	const { t } = useTranslation();
	const app = useApplication();

	const [code, setCode] = React.useState('');
	const [error, setError] = React.useState(false);

	const handleCodeChange = React.useCallback((e) => {
		const val = e?.target?.value ?? '';
		setCode(val.toUpperCase().replace(/[^A-Z]/g, ''));
	}, []);

	const handleJoinClick = React.useCallback((e) => {
		e?.preventDefault?.();
		e?.stopPropagation?.();

		(async () => {
			try {
				const result = await app.multiplayer.joinOrCreate(code, {
					playerName: app?.userdata?.name,
					name: app?.userdata?.name,
					avatar: app?.userdata?.avatar,
				});
				setRoom(result);
				setCode(result.roomId);
				setError(false);
			} catch (err) {
				console.log('error connecting to the server', err);
				setError(true);
			}
		})();
	}, [app, code, setRoom]);

	const interactionButton = React.useMemo(() => {
		if (error) {
			return (
				<>{t('There was an error connecting to the server.')}{' '}{t('Please try again later.')}</>
			);
		}

		if (room) {
			return null;
		}

		return (
			<a
				href="#"
				className="simpleButtonOutLine w-100"
				onClick={handleJoinClick}
			>
				{t('Enter')}
			</a>
		);
	}, [error, handleJoinClick, room, t]);

	return (
		<>
			<li>
				{t('Create or join an existing room')}
			</li>
			<li className="mb2">
				({t('4 letters or more')})
			</li>
			<li className="mb2">
				<input
					type="text"
					value={code}
					onChange={handleCodeChange}
					readOnly={!!room}
					placeholder={t('room name')}
					className="w-100"
				/>
			</li>
			<li className="mb2">
				{interactionButton}
			</li>
		</>
	);
};

export default CreateRoom;
